var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIqanaSymbolRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 305 305",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20 20h265v265h-265z",
    fill: "#00f25e"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 152.5,
    fill: "#00594f",
    r: 76.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIqanaSymbolRgb);
export default __webpack_public_path__ + "static/media/iqana_symbol_rgb.003937bfb9e9d47a8e7481e114606065.svg";
export { ForwardRef as ReactComponent };